export default __webpack_public_path__ + "static/media/g2022-14.61b5d2ab.jpeg";